import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fb7edc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["name"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ColorPopover = _resolveComponent("ColorPopover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      ref: "input",
      class: _normalizeClass(['color', { block: _ctx.block, dark: _ctx.dark }]),
      style: _normalizeStyle({ ..._ctx.style, backgroundColor: _ctx.modelValue }),
      name: _ctx.name,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPopover = !_ctx.showPopover))
    }, _toDisplayString(_ctx.modelValue), 15 /* TEXT, CLASS, STYLE, PROPS */, _hoisted_1),
    _createVNode(_component_ColorPopover, {
      "model-value": _ctx.modelValue,
      show: _ctx.showPopover,
      el: _ctx.$refs.input,
      "on-hide": _ctx.hidePopover,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
    }, null, 8 /* PROPS */, ["model-value", "show", "el", "on-hide"])
  ], 64 /* STABLE_FRAGMENT */))
}